<template>
    <v-card
        elevation="0"
        class="pb-6"
        :loading="ChartVentasObjetivo.isLoading"
    >
        <v-card-title
            class="d-flex justify-center"
        >
            <div
                class="overline"
                style="font-size: 1rem !important; color: black"
            >
                Total de ventas por tipo de objetivo
                <span
                    v-if="!ChartVentasObjetivo.isLoading"
                    style="font-size: 1.4rem !important; font-weight: bold"
                    >{{ getTotalVentasObjetivo }}</span
                >
            </div>
            <div class="ml-auto">
                <v-dialog
                    v-if="ChartVentasObjetivo.comerciales.length"
                    v-model="dialog"
                    persistent
                    max-width="500px"
                    transition="dialog-transition"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="red lighten-2"
                            dark
                            v-bind="attrs"
                            v-on="on"
                        >
                            Comerciales
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="d-flex">
                            <div
                                v-if="$vuetify.breakpoint.xs"
                                class="primary--text text-overline ml-2"
                            >
                                <v-icon left> mdi-info </v-icon>
                                Comerciales implicados
                            </div>
                            <div
                                v-else
                                class="
                                    font-weight-light
                                    primary--text
                                    text-h4
                                    ml-2
                                "
                            >
                                <v-icon large left> mdi-info </v-icon>
                                Comerciales implicados
                            </div>
                        </v-card-title>
                        <!-- <v-divider class="test"></v-divider> -->
                        <v-card-text class="mt-2 pb-0">
                            <v-list dense>
                                <v-list-item
                                    v-for="(
                                        value, index
                                    ) in ChartVentasObjetivo.comerciales"
                                    :key="index"
                                >
                                    {{ value }}
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                        <v-card-actions class="mx-2">
                            <v-spacer></v-spacer>
                            <v-btn color="red" text @click="dialog = false">
                                Cerrar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </v-card-title>
        <!-- <v-divider class="test"></v-divider> -->
        <v-tabs
            v-model="tab"
            class="d-flex flex-column"
            grow
            :show-arrows="$vuetify.breakpoint.smAndDown"
        >
            <v-tab>Diagrama de sectores</v-tab>
            <v-tab>Diagrama de barras</v-tab>
            <v-tab-item>
                <v-container
                    v-if="ChartVentasObjetivo.isLoading"
                    fill-height
                    fluid
                    class="text-center"
                >
                    <v-progress-circular
                        class="mx-auto"
                        :size="50"
                        :width="5"
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
                <div v-else-if="getTotalVentasObjetivo == 0">
                    <h4 class="mt-3 overline text-center">
                        No hay datos para mostrar
                    </h4>
                </div>
                <div v-else>
                    <PieChart
                        :chart-data="ChartVentasObjetivo.ventasObjetivo"
                        :options="optionsPieChart"
                    ></PieChart>
                </div>
            </v-tab-item>
            <v-tab-item>
                <v-container
                    v-if="ChartVentasObjetivo.isLoading"
                    fill-height
                    fluid
                    class="text-center"
                >
                    <v-progress-circular
                        class="mx-auto"
                        :size="50"
                        :width="5"
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
                <div v-else-if="getTotalVentasObjetivo == 0">
                    <h4 class="mt-3 overline text-center">
                        No hay datos para mostrar
                    </h4>
                </div>
                <div v-else>
                    <BarChart
                        :chart-data="ChartVentasObjetivo.ventasObjetivo"
                        :options="optionsBarChart"
                    ></BarChart>
                </div>
                <v-container v-else fill-height fluid class="text-center">
                    <v-progress-circular
                        class="mx-auto"
                        :size="50"
                        :width="5"
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import PieChart from './PieChart.js';
import BarChart from './BarChart.js';
export default {
    name: 'StatsVentasObjetivo',
    components: {
        PieChart,
        BarChart,
    },
    data: () => ({
        dialog: false,
        tab: 0,
        optionsPieChart: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                display: true,
                position: 'top',
                align: 'center',
                labels: {
                    padding: 10,
                },
            },
        },
        optionsBarChart: {
            maintainAspectRatio: false,
            responsive: true,
        },
    }),
    computed: {
        getTotalVentasObjetivo() {
            return this.ChartVentasObjetivo.ventasObjetivo.datasets[0].data.reduce(
                (a, b) => a + b,
                0
            );
        },
        ...mapState('statistics', {
            ChartVentasObjetivo: (state) => state.ChartVentasObjetivo,
        }),
    },
};
</script>

<style>
</style>